require('slick-carousel')
import has from 'lodash/has'
import qs from 'query-string'

const $slider = $('.js-product-image-wrapper ul')

    const handleActiveGridItem = (index = 0) => {
    $('.products-grid .js-products-grid__item.grid-item--active').removeClass('grid-item--active')
    $(`.products-grid .js-products-grid__item[data-index=${index}]`).addClass('grid-item--active')
    }

    const urlParams = qs.parse(window.location.search)
    const startIndex = has(urlParams, 'start') ? urlParams.start : 0

    handleActiveGridItem(startIndex)

    const setupSlider = () => {

    $slider.slick({
        dots: true,
        initialSlide: parseInt(startIndex),
    })

    $slider.on('beforeChange', (e, slick, current, next) => {
        handleActiveGridItem(next)
    })

    $('.products-grid').on('click', '.js-products-grid__item', e => {
        const index = $(e.currentTarget).data('index')
        $slider.slick('slickGoTo', index)
    })
    }


    setupSlider()


function firePrint() {

    $('.js-fire-print').on('click', function(){
        event.preventDefault();
        window.print();
    });    
}

firePrint()

  
